import React from 'react';
import PropTypes from 'prop-types';
import { classes } from './Center.st.css.js';
class Center extends React.PureComponent {
    static { this.propTypes = {
        children: PropTypes.node,
    }; }
    render() {
        const { children } = this.props;
        return React.createElement("div", { className: classes.center }, children);
    }
}
export default Center;
//# sourceMappingURL=Center.js.map